import React from "react";
import { Box, Typography } from "@mui/material";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

export default function PaymentPerformanceGraph({ data }) {
  if (!data || data.length === 0) {
    return (
      <Box sx={{ mt: 4, textAlign: "center" }}>
        <Typography>No hay datos para mostrar</Typography>
      </Box>
    );
  }

  // Obtener etiquetas y valores
  const labels = data.map(item => Object.keys(item)[0]);
  const values = data.map(item => Object.values(item)[0]);

  const chartData = {
    labels,
    datasets: [
      {
        label: "Monto",
        data: values,
        backgroundColor: [
          "#6ce5e8", 
          "#2d8bba",
        ],
      }
    ]
  };

  const options = {
    indexAxis: 'y',  // barras horizontales
    responsive: true,
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: ctx => `${ctx.label}: $${ctx.formattedValue}`,
        }
      }
    },
    scales: {
      x: {
        title: { display: true, text: "Monto ($)" },
        ticks: { beginAtZero: true }
      },
      y: {
        title: { display: false },
        ticks: { font: { size: 14 } }
      }
    }
  };

  return (
    <Box sx={{ width: "40%", ml: 2, mt: 3 }}>
      <Bar data={chartData} options={options} />
    </Box>
  );
}
